export default {
  methods: {
    render_pie1(data, width) {
      if(!data) return
      let list = [
        { saleNum: data.preYearSaleNumProportion, date: data.preTime, salesVolume: data.preYearSaleNum },
        { saleNum: data.thisYearSaleNumProportion, date: data.thisTime, salesVolume: data.thisYearSaleNum },
      ];
      let leftChart = list.map(v => {
        return {
          value: v.saleNum,
          name: v.date
        }
      })
      let colorList = ['#23BE72', '#F9DA4F']
      let option = {
        color: colorList,
        tooltip: {
          trigger: 'item',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          },
          formatter: (params) => {
            let index = params.dataIndex
            let str = "";
            if (typeof (params) != 'string') {
              str = `${params.marker}${params.name
                }<br/>销量<span style="inline-block;text-algin:left; float:right; font-weight:800; margin-left: 30px;">${parseInt(list[index].salesVolume).toLocaleString()}</span><br/>占比<span style="inline-block;text-algin:left; float:right; font-weight:800; margin-left: 30px;">${params.value + "%"
                }</span><br/>`;
            }
            return str;
          },
        },
        grid: {
          left: 0,
          top: 0,
          left: 0,
          bottom: 0,
          containLabel: true
        },
        legend: {
          data: list.map(v => v.date),
          bottom: width == 1920 ? 20 : 5,
          itemGap: width == 1920 ? 80 : 15,
          itemWidth: 15,
          textStyle: {
            color: '#fff',
            fontFamily: 'PingFangSC'
          }
        },
        series: [
          {
            // name: 'Access From',
            type: 'pie',
            radius: width == 1920 ? ['35%', '62%'] : ['30%', '52%'],
            center: ['52%', '48.5%'],
            minAngle: 5,  //设置扇形的最小占比
            label: {
              show: true,
              formatter: (params) => {
                return `${Math.round(params.percent)}%`
              },

              position: 'outside',
              bleedMargin: -5,
              fontFamily: 'PingFangSC',
              fontSize: width == 1920 ? '12px' : '10px'
              // overflow: 'break'
            },
            labelLine: {
              show: true,
              length: 5
            },
            data: leftChart.map((item, index) => {
              item.label = {
                color: colorList[index],
                borderColor: '#ffffff', //间隔为白色
              }
              return item;
            }),
          },
        ]
      };
      let $instance = this.$echarts.init(this.$refs['pie1']);
      $instance.setOption(option, true);
    }
  }
}